import { stripMarkdownToPlainText } from '@vrzl/ui/markdownPlainText';

import { evidenceSourceMatchesDocumentUrl } from '@/domains/report/api/evidenceSourceMatch';
import type { ValidationAnswer, ValidationReportItem } from '@/domains/report/api/types';

export type EvidenceQuote = {
  /** Citaat als platte tekst, zoals het in het document staat. */
  text: string;
  /** Undefined als de bron niet bij een document van het evenement hoort. */
  docName: string | undefined;
  /** Oplopend en ontdubbeld; leeg als de extractie er geen meegaf. */
  pages: number[];
};

/** Citaten uit de evidence van één waarde, in volgorde; evidence zonder tekst valt weg. */
export function evidenceQuotes(
  answer: ValidationAnswer,
  documents: ValidationReportItem['documents'],
): EvidenceQuote[] {
  return answer.evidence.flatMap((ev) => {
    const text =
      ev.plainSentence?.trim() || (ev.sentence ? stripMarkdownToPlainText(ev.sentence) : '');
    if (!text) return [];
    const doc = documents.find((d) => evidenceSourceMatchesDocumentUrl(ev.source, d.url));
    return [
      {
        text,
        docName: doc?.name,
        pages: [...new Set(ev.pages ?? [])].sort((a, b) => a - b),
      },
    ];
  });
}
